// extracted by mini-css-extract-plugin
module.exports = {"switchStyle":"EmployeeAllocationFilterForm_switchStyle__30zmC","clearBtnStyle":"EmployeeAllocationFilterForm_clearBtnStyle__1z6Zd"};